module.exports = __webpack_public_path__ + "static/media/7.9.0d7c4f7e.png";